export default "__VITE_ASSET__234p6KR5__"